module.exports = __webpack_public_path__ + "img/gallery5.cf666ee4.jpg";